export default __webpack_public_path__ + "static/pa_home-2cfb7fae9a3f33b775f05ebdd45dc858.png";